import React, { useEffect, useState } from "react";
import Loader from "../../layout/lodaer";
import OtherQuizes from "./otherQuizes";

function StartQuiz() {
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);
  return (
    <>
      {!loading ? (
        <>
          <>
            <div className="container main-quiz-start">
              <OtherQuizes />
            </div>
          </>
        </>
      ) : (
        <Loader />
      )}
    </>
  );
}

export default StartQuiz;
